<template>
  <div class="marketing-banner" v-if="hasDesktopImage && Object.keys(selectedCollectionCategory).length > 0">
    <div class="marketing-banner-img" :style="`--desktop-image: url('${desktopImg}');
    --tablet-image: url('${tabletImg}');
    --mobile-image: url('${mobileImg}')`"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: 'MarketingBanner',

  data() {
    return {
      desktopImg: null,
      tabletImg: null,
      mobileImg: null
    };
  },

  computed: {
    ...mapGetters([
      'selectedCollectionCategory',
      'allCollectionCategories'
    ]),

    hasDesktopImage() {
      if (Object.keys(this.selectedCollectionCategory).length > 0) {
        return this.selectedCollectionCategory.desktop_image_url !== null;
      }

      return false;
    }
  },

  watch: {
    selectedCollectionCategory: {
      deep: true,
      handler() {
        if (this.hasDesktopImage) {
          this.setImgUrls();
        }
      }
    }
  },

  created() {
    if (this.hasDesktopImage) {
      this.setImgUrls();
    }
  },

  methods: {
    setImgUrls() {
      const imageCategory = this.getImgCategory();

      if (imageCategory === undefined) return;

      this.desktopImg = imageCategory.desktop_image_url;
      this.tabletImg = imageCategory.tablet_image_url;
      this.mobileImg = imageCategory.mobile_image_url;
    },

    getImgCategory(category = this.selectedCollectionCategory) {
      if (Array.isArray(Object.values(category)) && (Object.values(category).length === 0)) return;

      if (category.desktop_image_url) return category;

      let parentCategory = null;

      for (let ref of category.parent_category_refs) {
        parentCategory = this.allCollectionCategories.find(cat => cat.id.toString() === ref.id.toString());

        if (parentCategory) break;
      }

      return this.getImgCategory(parentCategory);
    }
  }
}
</script>
